import { FC } from "react";
import { NodeProps } from "reactflow";
import { StepDto, StepExecutionDto } from "../../../../../dtos";
import { PlayViewerNode } from "../../Components/PlayViewerNode";
import { Merge } from "@mui/icons-material";
import { JOIN_NODE_DESCRIPTION } from "../../utils";

export const JoinPlayViewerNode: FC<NodeProps<StepDto | StepExecutionDto>> = (props) => {
    return <PlayViewerNode {...props} icon={<Merge fontSize='large' sx={{ transform: 'rotate(90deg)' }} />} description={JOIN_NODE_DESCRIPTION} disableEdit disableViewExecutionDetails />;
}